import React, { useState } from "react";

import { useSelector } from "react-redux";
import { MenuItemLink } from "react-admin";
import { withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ContactListIcon from "@material-ui/icons/ViewList";
import OrgIcon from "@material-ui/icons/Domain";
import ZoneOnIcon from "@material-ui/icons/LocationOn";
import PeopleIcon from "@material-ui/icons/People";
import WebhookIcon from "@material-ui/icons/Http";
import ContactIcon from "@material-ui/icons/ContactPhone";
import DispatchTabletIcon from "@material-ui/icons/Tablet";
import VideocamIcon from "@material-ui/icons/Videocam";
import MarketingIcon from "@material-ui/icons/ListAlt";
import FormIcon from "@material-ui/icons/BallotOutlined";
import VideosIcon from "@material-ui/icons/VideoLibrary";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";
import MyLocationIcon from "@material-ui/icons/MyLocation";

import useUser from "./hooks/useUser";

const useStyles = makeStyles({
  item: {},
  selectedItem: {
    fontWeight: "bold",
  },
  subItem: {
    marginLeft: "20px",
  },
  selectedSubItem: {
    marginLeft: "20px",
    fontWeight: "bold",
    backgroundColor: "#FAFAFA",
    transition: "backgroundColor 2s ease-in",
  },
});

export const Menu = () => {
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const classes = useStyles();
  const user = useUser();

  const Item = (page) => {
    return page === window.location.pathname
      ? classes.selectedItem
      : classes.item;
  };
  const SubItem = (page) => {
    return page === window.location.pathname
      ? classes.selectedSubItem
      : classes.subItem;
  };

  const orgAdminBelongInOrg =
    user.role === "org-admin" &&
    user.Organizations &&
    user.Organizations.length > 0;

  let [showOperations, toggleOperations] = useState(false);
  return (
    <div>
      <MenuItemLink
        key={"DashboardMenu"}
        to={"/"}
        primaryText={"Dashboard"}
        className={Item("/")}
        sidebarIsOpen={open}
        leftIcon={<DashboardIcon />}
      />

      {user.role === "super-admin" || user.role === "channel-admin"
        ? // Any pages only super admin should see can go here
          [
            <MenuItemLink
              key={"organizationsMenu"}
              to={"/organizations"}
              primaryText={"Organizations"}
              sidebarIsOpen={open}
              className={Item("/organizations")}
              leftIcon={<OrgIcon />}
            />,
            <MenuItemLink
              key={"AdministratorMenu"}
              to={window.location.pathname}
              primaryText={"Administrator Pages"}
              sidebarIsOpen={open}
              leftIcon={!showOperations ? <MenuOpenIcon /> : <ExpandMoreIcon />}
              onClick={() =>
                toggleOperations((showOperations = !showOperations))
              }
            />,
          ]
        : null}

      {user.role === "super-admin" && showOperations
        ? // Anything for the drop down menu can go here, make sure to assign className SubItem
          [
            // <MenuItemLink key={'formsMenu'} to={'/forms'} primaryText={'Forms'} className={SubItem('/forms')} sidebarIsOpen={open} leftIcon={<FormIcon />} />,
            // <MenuItemLink key={'marketingMenu'} to={'/marketing'} primaryText={'Marketing'} className={SubItem('/marketing')} sidebarIsOpen={open} leftIcon={<MarketingIcon />} />,
            // <MenuItemLink key={'videosMenu'} to={'/videos'} primaryText={'Videos'} className={SubItem('/videos')} sidebarIsOpen={open} leftIcon={<VideosIcon />} />,
            <MenuItemLink
              key={"zonesMenu"}
              to={"/zones"}
              primaryText={"Zones"}
              className={SubItem("/zones")}
              sidebarIsOpen={open}
              leftIcon={<ZoneOnIcon />}
            />,
            <MenuItemLink
              key={"dTMenu"}
              to={"/dispatch-tablets"}
              primaryText={"Dispatch Consoles"}
              className={SubItem("/dispatch-tablets")}
              sidebarIsOpen={open}
              leftIcon={<DispatchTabletIcon />}
            />,
            <MenuItemLink
              key={"contactsMenu"}
              to={"/contacts"}
              primaryText={"Contacts"}
              className={SubItem("/contacts")}
              sidebarIsOpen={open}
              leftIcon={<ContactIcon />}
            />,
            <MenuItemLink
              key={"cLMenu"}
              to={"/contactlists"}
              primaryText={"Contact Lists"}
              className={SubItem("/contactlists")}
              sidebarIsOpen={open}
              leftIcon={<ContactListIcon />}
            />,
            <MenuItemLink
              key={"usersMenu"}
              to={"/users"}
              primaryText={"Users"}
              sidebarIsOpen={open}
              className={SubItem("/users")}
              leftIcon={<PeopleIcon />}
            />,
            <MenuItemLink
              key={"webhooksMenu"}
              to={"/webhooks"}
              primaryText={"Webhooks"}
              sidebarIsOpen={open}
              className={SubItem("/webhooks")}
              leftIcon={<WebhookIcon />}
            />,
            <MenuItemLink
              key={"camera"}
              to={"/cameras"}
              primaryText={"Cameras"}
              sidebarIsOpen={open}
              className={SubItem("/camera")}
              leftIcon={<VideocamIcon />}
            />,
            <MenuItemLink
              key={"panel"}
              to={"/panels"}
              primaryText={"Panels"}
              sidebarIsOpen={open}
              className={SubItem("/panels")}
              leftIcon={<DeveloperBoardIcon />}
            />,
            <MenuItemLink
              key={"pendant"}
              to={"/pendants"}
              primaryText={"Pendants"}
              sidebarIsOpen={open}
              className={SubItem("/pendants")}
              leftIcon={<MyLocationIcon />}
            />,
          ]
        : null}

      {user.role === "channel-admin" && showOperations
        ? // Anything for the drop down menu can go here, make sure to assign className SubItem
          [
            // <MenuItemLink key={'formsMenu'} to={'/forms'} primaryText={'Forms'} className={SubItem('/forms')} sidebarIsOpen={open} leftIcon={<FormIcon />} />,
            // <MenuItemLink key={'marketingMenu'} to={'/marketing'} primaryText={'Marketing'} className={SubItem('/marketing')} sidebarIsOpen={open} leftIcon={<MarketingIcon />} />,
            // <MenuItemLink key={'videosMenu'} to={'/videos'} primaryText={'Videos'} className={SubItem('/videos')} sidebarIsOpen={open} leftIcon={<VideosIcon />} />,
            <MenuItemLink
              key={"usersMenu"}
              to={"/users"}
              primaryText={"Users"}
              sidebarIsOpen={open}
              className={SubItem("/users")}
              leftIcon={<PeopleIcon />}
            />,
          ]
        : null}
      {orgAdminBelongInOrg
        ? // Org-Admins should only be able to access pages if they are an org-admin with an org
          // Any pages only org admin should see can go here
          [
            <MenuItemLink
              key={"orgCMenu"}
              to={"/contacts"}
              primaryText={"Contacts"}
              className={Item("/contacts")}
              sidebarIsOpen={open}
              leftIcon={<ContactIcon />}
            />,
            <MenuItemLink
              key={"orgCLMenu"}
              to={"/contactlists"}
              primaryText={"Contact Lists"}
              className={Item("/contactlists")}
              sidebarIsOpen={open}
              leftIcon={<ContactListIcon />}
            />,
            <MenuItemLink
              key={"orgUsersMenu"}
              to={"/users"}
              primaryText={"Account Settings"}
              sidebarIsOpen={open}
              className={Item("/users")}
              leftIcon={<PeopleIcon />}
            />,
          ]
        : null}
    </div>
  );
};

export default withRouter(Menu);
